import { Button, Modal } from "@veneer/core";

export const ModalMessageAgenda = ({
  openModal,
  closeModal,
  title,
  message
}: any) => {
  return (
    <Modal
    align="center"
    id="modal-id"
    show={openModal}
    onClose={() => closeModal(false)}
    footer={<Button onClick={() => closeModal(false)}>Ok</Button>}
    title={title}
  >
    <p>{message}</p>
  </Modal>
  );
};
